import React, { Fragment, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from 'ThemeContext';
import { AppSettingsContext } from 'AppSettingsContext';

import {
  Wrapper,
  Container,
  Box,
  Item,
  ItemExternal,
  Text
} from './FooterMenu.style';

function FooterMenu({ menu = [] }) {
  const theme = useTheme();
  const location = useLocation();
  const [appSettings] = useContext(AppSettingsContext);

  const checkIsActiveChildren = item => {
    if (item.slug && location.pathname.endsWith(`/${item.slug}`)) return true;
    return item.data && item.data.length > 0
      ? item.data.reduce((currentState, item) => {
          if (!currentState) currentState = checkIsActiveChildren(item);
          return currentState;
        }, false)
      : false;
  };

  return (
    <>
      {menu && menu.length > 0 ? (
        <Wrapper theme={theme.footerMenu.wrapper}>
          <Container
            widerTheme={appSettings.theme === 6 ? String(true) : undefined}
            narrowerTheme={appSettings.theme === 4 ? String(true) : undefined}
          >
            <Box>
              {menu.map((option, key) => {
                const isActive = checkIsActiveChildren(option);
                return (
                  <Fragment key={key}>
                    {(option.slug && /(http(s?)):\/\//gi.test(option.slug)) ||
                    (option.url && /(http(s?)):\/\//gi.test(option.url)) ||
                    option.url_outside ? (
                      <ItemExternal
                        theme={theme.footerMenu.item}
                        active={isActive ? isActive.toString() : undefined}
                        href={option.slug || option.url || option.url_outside}
                        target={
                          option._blank ||
                          option.url_blank ||
                          option.url_outside_blank
                            ? '_blank'
                            : '' || option.target || ''
                        }
                        rel={
                          option.nofollow ||
                          option.url_nofollow ||
                          option.url_outside_nofollow
                            ? 'nofollow'
                            : '' || option.rel || ''
                        }
                      >
                        <Text theme={theme.footerMenu.text}>{option.name}</Text>
                      </ItemExternal>
                    ) : option.slug || option.url ? (
                      <Item
                        theme={theme.footerMenu.item}
                        active={isActive ? isActive.toString() : undefined}
                        smooth
                        to={(() => {
                          let slug;
                          if (option.slug)
                            slug =
                              option.slug[0] === '/'
                                ? option.slug
                                : `/${option.slug}`;
                          else if (option.url)
                            slug =
                              option.url[0] === '/'
                                ? option.url
                                : `/${option.url}`;
                          else slug = '';

                          return slug;
                        })()}
                      >
                        <Text theme={theme.footerMenu.text}>{option.name}</Text>
                      </Item>
                    ) : (
                      ''
                    )}
                  </Fragment>
                );
              })}
            </Box>
          </Container>
        </Wrapper>
      ) : (
        ''
      )}
    </>
  );
}

export default FooterMenu;
